import React from 'react';
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import './login.css';
import logo from '../components/logo512.png';
import * as actions from '../store/actions/auth';


class NormalLoginForm extends React.Component {
  constructor(props){
    super(props);
    
    this.state = {
      userName : '',
      password : '',
      buttonValue : true
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }
  handleUsernameChange = (event) => {
    
    this.setState({userName: event.target.value});
    if (this.state.password.trim() !== '' && event.target.value.trim() !== ''){
      this.setState({
        buttonValue: false
      });  
    }
    else {
      this.setState({
        buttonValue: true
      });
    }
    }; 
    handlePasswordChange = (event) => {
     
      this.setState({password: event.target.value});
      if (event.target.value.trim() !== '' && this.state.userName.trim() !== ''){
        this.setState({
          buttonValue: false
        }); 
      }
      else {
        this.setState({
          buttonValue: true
        });
      }
      }; 
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onAuth(e.target.elements.userName.value, e.target.elements.password.value);
        
         
    }
    componentDidUpdate(prevProps) {
      if (this.props.token) {
        this.props.history.push('/HistoryList/')  
      } }
    
    render() {
      
        let errorMessage = null;
    if (this.props.error) {
        errorMessage = (
            <h2>The username or password you entered is incorrect.</h2>
        );
    }
      return (
        <div className='bodyy'>
        <div id="login-box">
            {errorMessage}
           {  this.props.loading ?
           <div className='footer-logo'>
            <h1 >Please wait</h1>
            <img  className='App-logo' src={logo} alt='logo'/> </div>
             :
        <div className="box">
                   
  <h1> Please login <span> or <NavLink to='/signup/'> Click HERE to register.</NavLink></span></h1>
   
        <form onSubmit={this.handleSubmit} id="formElem" className="login-form">
          <label>
            Username:
            <input name="userName" type="text" onChange={this.handleUsernameChange} placeholder="Please input your username!"/>        </label>
            <label>
            Password:
            <input name="password" type="password" onChange={this.handlePasswordChange} placeholder="Please input your Password!"/>        </label>
         <div className='another_div'> <input type="submit" value="Login"  disabled={this.state.buttonValue}/>
          <NavLink id ="homepage"
                        style={{marginRight: '10px',
                                paddingLeft: '5px'  }} 
                        to='/'>Homepage
                    </NavLink>
                    </div>
        </form> 

        
        </div> }
        </div>
        </div>
      );
    }
  }
  

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        error: state.error,
        token: state.token
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, password) => dispatch(actions.authLogin(username, password)) 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NormalLoginForm);  